module.exports = __webpack_public_path__ + "static/restaurant-3c238f02bef62669b3e7123d93745d43.jpg";